import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles, Slide } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import Selector2 from "../Selector2";
// import countries from "../../utils/countries";
// import { nationalities } from "../../utils/country-codes";
import {
  submitProfile,
  cleanProfileResponse,
  pushNotification,
  fetchCountries,
  fetchNationalities,
} from "../../actions/index";
import { notification } from "../../utils/notifications";
import { images } from "../../utils/images";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import Loader from "../Loader";

const fullNameCountries = ["CN", "KR", "TH", "JP"];

function Profile(props) {
  const { classes, t, nationality, profileResponse, countries, nationalities } =
    props;
  const [countryOfResidence, setCountryOfResidence] = useState("");
  const [fName, setFname] = useState("");
  const [mName, setMname] = useState("");
  const [lName, setLname] = useState("");
  const [dob, setDob] = useState(null);
  const [nationalityLocal, setNationalityLocal] = useState("");
  const [missingFields, setMissingFields] = useState([]);
  const [countryNeedsFullName, setCountryNeedsFullName] = useState(false);
  const [fullName, setFullName] = useState("");
  const [submittingProfile, setSubmittingProfile] = useState(false);
  const [countriesArray, setCountriesArray] = useState([]);
  const [nationalitiesArray, setNatArray] = useState([]);

  // Component Did Mount
  useEffect(() => {
    props.fetchCountries();
    if (nationality === "") {
      props.fetchNationalities();
    }
  }, []);

  useEffect(() => {
    if (countries) {
      let countriesArrayMap = countries.map((c) => c.name);
      setCountriesArray([...countriesArrayMap]);
    }
  }, [countries]);

  useEffect(() => {
    if (nationalities) {
      let natArray = [];

      nationalities.map((n) => {
        natArray.push(n.name);
      });

      setNatArray([...natArray]);
    }
  }, [nationalities]);

  useEffect(() => {
    let country;
    if (countries) {
      country = countries.find((c) => c.name === countryOfResidence);
    }

    if (country) {
      if (fullNameCountries.includes(country.alpha2)) {
        setCountryNeedsFullName(true);
      } else {
        setCountryNeedsFullName(false);
      }
    }
  }, [countryOfResidence]);

  const finishProfile = () => {
    setSubmittingProfile(true);
    const country = countries.find((c) => c.name === countryOfResidence);

    const profile = {
      first_name: fName,
      middle_name: mName,
      first_last_name: lName,
      international_full_name: `${fName} ${mName} ${lName}`,
      country: country?.alpha2 ? country.alpha2 : "",
      birthdate: dob ? dob.split(" ").join("-") : "",
      nationality: nationality === "" ? nationalityLocal : nationality,
    };

    if (countryNeedsFullName) {
      profile.international_full_name = fullName;
    }

    let missingFields = [];

    Object.keys(profile).map((i) => {
      if (i !== "middle_name" && profile[i] === "") {
        missingFields.push(i);
      }
    });

    if (missingFields.length) {
      setMissingFields(missingFields);
      setSubmittingProfile(false);
      return props.pushNotification({
        message: "missingFields",
        type: "error",
      });
    }

    props.addProfile(profile);
    props.submitProfile(profile);
  };

  const handleDateChange = (date) => {
    if (date === null) {
      setDob(null);
    } else {
      let formattedDate = date.format("YYYY-MM-DD");

      if (formattedDate !== "Invalid date") {
        let now = moment();
        let birthdate = moment(formattedDate);

        let isAfter = birthdate.isAfter(now);
        let diff = now.diff(birthdate, "years");

        if (isAfter) {
          props.pushNotification({
            message: "_invalidDateFuture",
            type: "error",
          });
          setDob(null);
        } else if (diff < 18) {
          props.pushNotification({
            message: "_invalidDateNot18",
            type: "error",
          });
          setDob(null);
        } else {
          setDob(formattedDate);
        }
      } else {
        setDob(formattedDate);
      }
    }
  };
  useEffect(
    function () {
      if (profileResponse.isProfileSubmitted) {
        notification(t("profileSubmitted"), "success");
        props.cleanProfileResponse();
        props.moveForward(true);
      } else {
        setSubmittingProfile(false);
      }
    },
    [profileResponse]
  );

  if (countries === null || nationalities === null) {
    return (
      <div style={{ marginTop: 24 }}>
        <Loader />
      </div>
    );
  }

  return (
    <Slide in direction="left">
      <div className={classes.container}>
        <h2>{t("tellUsAboutYou")}</h2>
        <p className="subtitle">{t("typeName")}</p>
        <div className="stepBody">
          <div className="left">
            <p className="label">{t("countryOfResidence")}</p>
            <Selector2
              options={countriesArray}
              width="100%"
              selectorHandle={setCountryOfResidence}
              selectedOption={countryOfResidence}
              invalid={missingFields.includes("country") ? true : false}
            />
            {nationality === "" ? (
              <p className="label">{t("nationality")}</p>
            ) : (
              ""
            )}
            {nationality === "" ? (
              <Selector2
                options={nationalitiesArray}
                selectorHandle={setNationalityLocal}
                selectedOption={nationalityLocal}
                width="100%"
                invalid={missingFields.includes("nationality") ? true : false}
              />
            ) : (
              ""
            )}
            <p className="label">{t("fullName")}</p>
            <input
              type="text"
              className={`textInput ${
                missingFields.includes("first_name") ? "invalidField" : ""
              }`}
              value={fName}
              onChange={(e) => setFname(e.target.value)}
              placeholder={t("firstName")}
              maxLength="64"
            />
            <input
              type="text"
              className="textInput"
              value={mName}
              onChange={(e) => setMname(e.target.value)}
              placeholder={t("middleName")}
              maxLength="64"
            />
            <input
              type="text"
              className="textInput"
              value={lName}
              onChange={(e) => setLname(e.target.value)}
              placeholder={t("lastName")}
              maxLength="64"
              className={`textInput ${
                missingFields.includes("first_last_name") ? "invalidField" : ""
              }`}
            />
            {countryNeedsFullName ? (
              <input
                type="text"
                className="textInput"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder={t("internationalName")}
                maxLength="64"
                className={`textInput ${
                  missingFields.includes("international_full_name")
                    ? "invalidField"
                    : ""
                }`}
              />
            ) : (
              ""
            )}
            <p className="label">{t("dob")}</p>
            {/* <input
              type="date"
              className="textInput"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              className={`textInput ${
                missingFields.includes("birthdate") ? "invalidField" : ""
              }`}
            /> */}
            <KeyboardDatePicker
              value={dob}
              onChange={(e) => handleDateChange(e)}
              views={["year", "month", "date"]}
              format="YYYY/MM/DD"
              classes={{ root: classes.picker }}
              placeholder="YYYY/MM/DD"
            />
            <button
              className="confirmBtn"
              disabled={submittingProfile}
              onClick={() => finishProfile()}
            >
              {t("confirm")}
            </button>
          </div>
          <div className="right">
            <img
              style={{ width: "100%", height: "auto", objectFit: "contain" }}
              src={images.illustrations.profileIllustrationSolo}
            />
          </div>
        </div>
      </div>
    </Slide>
  );
}

function mapStateToProps(state) {
  return {
    profileResponse: state.profileResponse,
    countries: state.countries,
    nationalities: state.nationalities,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      submitProfile,
      cleanProfileResponse,
      pushNotification,
      fetchCountries,
      fetchNationalities,
    },
    dispatch
  );
}

const styles = (theme) => ({
  picker: {
    width: "100%",
    "& input": {
      paddingTop: 0,
      paddingBottom: 0,
    },
    "& .MuiInput-underline:after, & .MuiInput-underline:before": {
      borderBottomColor: "transparent",
    },
    "& .MuiOutlinedInput-root": {
      "&:hover": {
        borderColor: "transparent",
      },
    },
  },
  container: {
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    background: theme.colors.background.fore,
    boxShadow: theme.defaults.shadow,
    maxWidth: 880,
    width: "90%",
    padding: 40,
    color: theme.colors.text.primary,
    [theme.breakpoints.down(500)]: {
      padding: 24,
    },

    "& h2": {
      fontSize: 28,
      fontWeight: 600,
      marginBottom: 40,
    },

    "& .subtitle": {
      fontSize: 14,
      color: theme.colors.text.secondary,
    },

    "& .stepBody": {
      display: "flex",
      marginTop: 12,
      width: "100%",
      justifyContent: "space-between",

      "& .left": {
        width: "50%",
        position: "relative",

        "& .label": {
          color: theme.colors.text.primary,
          marginBottom: 8,
          marginTop: 16,
          fontWeight: 600,
          fontSize: 16,
          "&:first-of-type": {
            marginTop: 0,
          },
        },
        "& .selected": {
          marginRight: 0,
        },

        "& input": {
          ...theme.defaults.input,
          maxWidth: "none",
        },
        "& .textInput": {
          maxWidth: "100%",
          marginBottom: 8,
          "&.invalidField": {
            borderColor: theme.colors.buttons.red,
          },
        },

        "& .confirmBtn": {
          ...theme.defaults.roundBtn,
          background: theme.colors.buttons.green,
          marginTop: 32,
          float: "right",
        },
      },
      "& .right": {
        width: "45%",
        height: 300,
      },

      [theme.breakpoints.down(700)]: {
        "& .left": {
          width: "100%",
        },
        "& .right": {
          display: "none",
        },
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Profile))
);
